<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">入住编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="入住套餐" required prop="checkinSetmealCode">
                                    <el-select v-model="editForm.checkinSetmealCode" placeholder="请选择入住套餐" @change="getListBerthValue" style="width:100%">
                                        <el-option
                                                v-for="item in setmealList"
                                                :key="item.checkinSetmealCode"
                                                :label="item.name"
                                                :value="item.checkinSetmealCode">
                                                <span style="float: left">{{ item.name }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.univalence }}(元/天)</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item" v-show="editForm.checkinSetmealCode">
                                <el-form-item label="床号" required prop="berthCode">
                                    <el-cascader
                                        v-model="editForm.berthCode"
                                        placeholder="请选择床号"
                                        :options="ListBerth" :props="props" style="width:100%"></el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="预计入住时间" required prop="beginTimePlan">
                                    <el-date-picker
                                        v-model="editForm.beginTimePlan"
                                        type="date"
                                        style="width:100%;"
                                        value-format="yyyy-MM-dd"
                                        placeholder="预计入住时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="预计退住时间" required prop="endTimePlan">
                                    <el-date-picker
                                        v-model="editForm.endTimePlan"
                                        type="date"
                                        style="width:100%;"
                                        value-format="yyyy-MM-dd"
                                        placeholder="预计退住时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="入住类型" required prop="type">
                                    <el-select v-model="editForm.type" placeholder="请选择入住类型" style="width:100%">
                                        <el-option
                                            v-for="(item,i) in typeValue"
                                            :key="i"
                                            :label="item"
                                            :value="i">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        props:['setmealList'],
        data() {
            return {

                loading: false,
                ListBerth: [],
                typeValue:['正式入住','试住','预约入住'],
                roomTypeValue:['单人间','双人间'],
                datetimerangeValue:'',
                props: {
                    emitPath:false,
                    value: 'value',
                    // 显示的文字字段名
                    label: 'label',
                    // 子层级字段名
                    children: 'children'
                },
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    checkinSetmealCode:'',
                    berthCode:'',
                    type:'',
                    beginTimePlan:'',
                    endTimePlan:'',
                    checkinCode:'',
                    chargeType:1,
                    feeArr:[]
                },
                // pickerOption: {
                //     disabledDate(time) {
                //         return time.getTime() < Date.now() - 8.64e7;
                //     },
                // },
                rules:{
                    checkinSetmealCode:[
                        { required: true, message: '请选择入住套餐', trigger: 'blur' },
                    ],
                    berthCode:[
                        { required: true, message: '请选择床号', trigger: 'blur' },
                    ],
                    beginTimePlan:[
                        { required: true, message: '请选择预计入住时间', trigger: 'blur' },
                    ],
                    endTimePlan:[
                        { required: true, message: '请选择预计退住时间', trigger: 'blur' },
                    ],
                    type:[
                        { required: true, message: '请选择入住类型', trigger: 'blur' },
                    ],

                }


            }
        },

        methods: {
            init(row){
                this.$refs.editForm.resetFields();
                this.editForm.elderlyCode=row.elderlyCode;
                this.editForm.checkinSetmealCode=row.checkinSetmealCode;
                this.editForm.beginTimePlan = row.beginTimePlan;
                this.editForm.endTimePlan = row.endTimePlan;
                this.editForm.type=row.type;
                this.editForm.checkinCode=row.checkinCode;
                this.editForm.berthCode=row.berthCode;
                this.getListBerthValue(1);
            },
            getListBerthValue(num){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Berth/ListBerth",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        checkinSetmealCode:this.editForm.checkinSetmealCode,
                        berthCode:this.editForm.berthCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            if(num!=1){
                                this.editForm.berthCode=''
                            }
                            var datas=response.data.data
                            var JSONData=JSON.stringify(datas);
                            JSONData=JSONData.replace(/listRoomDTO/g,'children');
                            JSONData=JSONData.replace(/listBerth/g,'children');
                            JSONData=JSONData.replace(/name/g,'label');
                            JSONData=JSONData.replace(/number/g,'label');
                            var list=this.getListBerth(JSON.parse(JSONData),0)
                            JSONData=JSON.stringify(list);
                            JSONData=JSONData.replace(/buildingCode/g,'value');
                            JSONData=JSONData.replace(/roomCode/g,'value');
                            JSONData=JSONData.replace(/berthCode/g,'value');
                            this.ListBerth=JSON.parse(JSONData);
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            getListBerth(list,level){
                for(var i in list){
                    if(level==1){
                        list[i].buildingCode=list[i].roomCode
                    }
                    if(level==2){
                        list[i].roomCode=list[i].berthCode
                    }
                    if(level<2){
                        this.getListBerth(list[i].children,level+1)
                    }
                }
                return list;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Checkin/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
